// Mayasurts review slider
class MayaReviews extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.maya-reviews__track');
    if (!this.track) return;
    this.cards = [...this.track.children];
    this.dots = this.querySelector('.maya-reviews__dots');
    this.arrows = [...this.querySelectorAll('.maya-reviews__arrow')];
    this.dots.innerHTML = this.cards.map(() => '<span></span>').join('');
    this.arrows.forEach((b) => b.addEventListener('click', () => this.go(Number(b.dataset.dir))));
    this.track.addEventListener('scroll', () => requestAnimationFrame(() => this.update()), { passive: true });
    window.addEventListener('resize', () => this.update(), { passive: true });
    this.update();
  }
  step() {
    return this.cards[0] ? this.cards[0].getBoundingClientRect().width + 12 : this.track.clientWidth;
  }
  go(dir) {
    this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
  }
  update() {
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    const i = Math.round(this.track.scrollLeft / this.step());
    [...this.dots.children].forEach((d, n) => d.classList.toggle('is-active', n === i));
    if (this.arrows[0]) this.arrows[0].disabled = this.track.scrollLeft <= 2;
    if (this.arrows[1]) this.arrows[1].disabled = this.track.scrollLeft >= max;
    this.classList.toggle('maya-reviews--static', max <= 0);
  }
}
if (!customElements.get('maya-reviews')) customElements.define('maya-reviews', MayaReviews);
